/* eslint-disable react/prop-types */
import React, { useEffect, useReducer, useState } from 'react';


import {  Row, Col, Table, Spin,  message, Space, Modal, Button, Tag  } from 'antd';
import {  DeleteOutlined  } from '@ant-design/icons';

import { Content } from 'antd/es/layout/layout';
import { OPTIONAL_PATH_LIST, OPTIONAL_PATH_LIST_SUCCESS, OPTIONAL_PATH_LIST_ERROR, DELETE_OPTIONAL_PATH, DELETE_OPTIONAL_PATH_SUCCESS, DELETE_OPTIONAL_PATH_ERROR, OPTIONAL_PATH_LIST_DETAILS_ERROR, OPTIONAL_PATH_LIST_DETAILS, OPTIONAL_PATH_LIST_DETAILS_SUCCESS } from './constants';



import englan from '../../english.json';
import germanlan from '../../german.json';
import arabiclan from '../../arabic.json';
import frenchlan from '../../french.json';
import hindilan from '../../hindi.json';
import malayalamlan from '../../malayalam.json';

import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import AllocationReducer from './reducer';
import { useAuth } from '../Context';

export default function Path(props) {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const initalState = {path : [], details: null, pending: false, error: false , pagination: { total: 0, limit: 10, skip: 0, current:1 }};
	const [data, dispatch] = useReducer(AllocationReducer, initalState);
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const [showDeletePathModal, setShowDeletePathModal] = useState(false);
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;

	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	// const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	useAuth();
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const navigate = useNavigate();
	const {userId } = props;


	const columns = [

		{
			title: langdata && langdata.Action ? langdata.Action : 'Action',
			dataIndex: 'action',
			key: 'action',
            
		},
		{
			title: langdata && langdata.ChainageFrom ? langdata.ChainageFrom : 'Chainage From',
			dataIndex: 'chainageFrom',
			key: 'chainageFrom',
            
		},
		{
			title: `${langdata && langdata.ChainageTo ? langdata.ChainageTo :'Chainage To'}`,
			dataIndex: 'chainageTo',
			key: 'chainageTo',
			
		},
		{
			title: `${langdata && langdata.Status ? langdata.Status :'Status'}`,
			dataIndex: 'status',
			key: 'status',
			render: (status) => (
				<>
					<Tag
						color={
							status =='NEW' ? 'red' : 'green'
						}
					>
						{status}
					</Tag>
				</>
			),
		},
		{
			title: `${langdata && langdata.Region ? langdata.Region :'Region'}`,
			dataIndex: 'regionName',
			key: 'regionName',
		},
		{
			title: `${langdata && langdata.UserName ? langdata.UserName :'User Name'}`,
			dataIndex: 'userName',
			key: 'userName',
		},
		{
			title: `${langdata && langdata.Allocation ? langdata.Allocation :'Allocation'}`,
			dataIndex: 'allocations',
			key: 'allocations',
			
		},
		{
			title: `${langdata && langdata.Date ? langdata.Date :'Date'}`,
			dataIndex: 'date',
			key: 'date',
			
		},
		{
			title: `${langdata && langdata.PathName ? langdata.PathName :'Path Name'}`,
			dataIndex: 'currentPath',
			key: 'currentPath',
			
		},
		{
			title: `${langdata && langdata.Actions ? langdata.Actions:'Actions'}`,
			key: 'attachmentUrls',
			align:'center',
			render: (_,record) => (
						
		
				<>
					<Space style={{justifyContent:'center',display:'flex'}} size="middle">
						<Button disabled={record.status == 'NEW' ? false : true} type='link' title={langdata && langdata.Delete ? langdata.Delete :'Delete'} onClick={openDeleteAssetsModal}><DeleteOutlined /></Button> 
					</Space>
				</>
			)
		}
	];



	useEffect(() => {
		if(!authtoken){
			navigate('/');
		}
	},[authtoken]);

	useEffect(() => {
		// if(featuresModule.speedClassificationEnabled == false) {
		// 	navigate('/dashboard');
		// }
        
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' ,4010);
	}, []);

	
	useEffect(() => {
		dispatch( { type: OPTIONAL_PATH_LIST });
      
		loadPath(1);
        
	}, []);

	const loadPath = (pagination) => {

		let _pagination = { };
		_pagination.total = data.pagination.total ? data.pagination.total : 0;
		_pagination.limit = pagination.pageSize ? pagination.pageSize : 10;
		_pagination.skip =  pagination.current    ? parseInt((pagination.current-1) * pagination.pageSize) : 0;
		_pagination.pageSize =  pagination.pageSize ? pagination.pageSize : 10;
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/redefinepipelineconfig?userId=${userId}&pipelineId=${pipelineId ? parseInt(pipelineId) : null}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};

		axios
			.request(config)
			.then((response) => {                
				if (response.status === 200) {
					dispatch({type:OPTIONAL_PATH_LIST_SUCCESS, page:pagination.current, pageSize : pagination.pageSize , payload: response.data});
				}
                
			})
			.catch((error) => {
				dispatch({type:OPTIONAL_PATH_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

		
	

	const openDeleteAssetsModal = () => {
		setShowDeletePathModal(true);
	};

	const deletePath = () => {
		const id = parseInt(data.details.id);
			
		dispatch({ type: DELETE_OPTIONAL_PATH });
		
		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/redefinepipelineconfig/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
		
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_OPTIONAL_PATH_SUCCESS, payload: response});
					setShowDeletePathModal(false);   
					loadPath(1);
				} else {
					dispatch({type:DELETE_OPTIONAL_PATH_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:DELETE_OPTIONAL_PATH_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const closeDeletePathModal = () => {
		setShowDeletePathModal(false);
	};

	const loadPathDetails = ((record) => {
	
		dispatch( { type: OPTIONAL_PATH_LIST_DETAILS });
		
		if (!record) {
			dispatch({ type: OPTIONAL_PATH_LIST_DETAILS_ERROR });
		} else {
			dispatch({ type: OPTIONAL_PATH_LIST_DETAILS_SUCCESS, payload: record });
	
		}
	
	});

	
    
	return (
		<>
			<Content>
                    
				<Row span={24} style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={24}>
						<Table
							scroll={{
								x: 900,
							}} 
							columns={columns} 
							dataSource={data.path} 
							pagination = { data.path.length > 0 ? data.pagination : 0 }
							onChange={loadPath}           
							onRow = {(record) => {
								return {
									onClick: () => { 
										loadPathDetails(record);
											
												
									}
								};
							}}                         
						/>
						
					</Col>
				</Row>
			</Content>
			<Modal title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'} open={showDeletePathModal} onOk={deletePath} onCancel={closeDeletePathModal}>
				<Row style={{
					marginTop: '10px',
					marginBottom: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={1}>
						{/* <DeleteOutlined style={{ fontSize: '14px'}}/> */}
					</Col>
					<Col span={23}> { langdata && langdata.AreYouSureYouWantToDeleteThisPath ? langdata.AreYouSureYouWantToDeleteThisPath : 'Are you sure you want to delete this path' }</Col>
				</Row>
			</Modal>

			<Spin fullscreen spinning={data.pending} />
		</> 


            
	);

    
}